import ResetPassword from './ResetPassword.vue';
import ForgotPassword from './ForgotPassword.vue';
import SsoCallback from './SsoCallback.vue';
import { isSuperTokensAuth, isSuperTokensSso } from '@/libs/superTokens';

const requireSuperTokens = (to, from, next) => {
  if (!isSuperTokensAuth()) {
    return next({ path: '/login' });
  }
  return next();
};

const requireSuperTokensSso = (to, from, next) => {
  if (!isSuperTokensSso()) {
    return next({ path: '/login' });
  }
  return next();
};

export default [
  {
    path: '/auth/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    beforeEnter: requireSuperTokens,
    meta: {
      auth: false,
      resource: '/auth/reset-password',
    },
  },
  {
    path: '/auth/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    beforeEnter: requireSuperTokens,
    meta: {
      auth: false,
      resource: '/auth/forgot-password',
    },
  },
  {
    path: '/auth/callback',
    name: 'SsoCallback',
    component: SsoCallback,
    beforeEnter: requireSuperTokensSso,
    meta: {
      auth: false,
      resource: '/auth/callback',
    },
  },
];
